import React from 'react'
import { Table, Input, InputNumber, Button, Form, Empty } from 'antd'
import { MinusCircleOutlined, ShoppingOutlined } from '@ant-design/icons'
import { formatCurrency } from '../../../../InventoryItems/utils/helpers'

const OrderItemsTable = ({ orderItems, updateItemQuantity, removeOrderItem, totalCost }) => {
  // Columns for the order items table
  const orderItemColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '35%'
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      width: '20%',
      render: (quantity, record) => (
        <InputNumber min={1} value={quantity} onChange={(value) => updateItemQuantity(record.itemId, value)} />
      )
    },
    {
      title: 'Unit Cost',
      dataIndex: 'unitCost',
      key: 'unitCost',
      width: '20%',
      render: (cost) => formatCurrency(cost)
    },
    {
      title: 'Total',
      dataIndex: 'totalCost',
      key: 'totalCost',
      width: '15%',
      render: (cost) => formatCurrency(cost)
    },
    {
      title: 'Actions',
      key: 'actions',
      width: '10%',
      render: (_, record) => (
        <Button type='text' danger icon={<MinusCircleOutlined />} onClick={() => removeOrderItem(record.itemId)} />
      )
    }
  ]

  return (
    <div style={{ marginTop: 24 }}>
      {orderItems.length > 0 ? (
        <Table
          dataSource={orderItems}
          columns={orderItemColumns}
          rowKey='itemId'
          pagination={false}
          size='small'
          style={{ width: '100%' }}
          summary={() => (
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={3}>
                <strong>Total</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={3}>
                <strong>{formatCurrency(totalCost)}</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={4} />
            </Table.Summary.Row>
          )}
        />
      ) : (
        <Empty
          image={<ShoppingOutlined style={{ fontSize: 48, color: '#1890ff' }} />}
          description={
            <span>No items in order yet. Use the search bar above to add items to your purchase order.</span>
          }
          style={{
            backgroundColor: '#f5f5f5',
            padding: '32px',
            borderRadius: '4px'
          }}
        />
      )}

      {/* Store total cost in a hidden form field */}
      <Form.Item name='totalCost' hidden>
        <Input />
      </Form.Item>
      <Form.Item name='supplierName' hidden>
        <Input />
      </Form.Item>
    </div>
  )
}

export default OrderItemsTable
